import React from 'react';
import { Home } from '../../components/navigation/Home';
import { MyApps } from '../../components/navigation/MyApps';
import { Docs } from '../../components/navigation/Docs';
import { Status } from '../../components/navigation/Status';
import { FAQ } from '../../components/navigation/FAQ';
import { UserMenu } from '../../components/user-menu';
import { Variant } from '../types';

const developer: Variant = {
  title: 'Developer',
  getMenuItems: (): JSX.Element[] => {
    return [
      <Home key="menu-home" />,
      <MyApps key="menu-myapps" />,
      <Docs key="menu-docs" />,
      <Status key="menu-status" />,
      <FAQ key="menu-faq" />,
    ];
  },
  actions: [],
  info: [],
  user: [<UserMenu key="menu-user" />],
  homePage: '/',
};

export default developer;
